<template>
  <div class="main-head">
    <div class="main-head-con">
      <div class="head-logo" @click="clickfhsy">
        <el-image
          style="width: 500px; height: 80px"
          :src="require('@/assets/img/common/logo.png')"
        ></el-image>
      </div>
      <div class="head-login" v-if="islogin">
        <div class="head-logins">
          <el-link type="primary" @click="logins">登录</el-link>
        </div>
        <div class="head-logins">
          <el-button size="large" @click="registered">注册</el-button>
        </div>
      </div>
      <div class="head-logout" v-if="!islogin">
        <div class="head-logins-dl" @click="clickgrzx">{{ headusername }}</div>
        <div class="head-logins">
          <el-button size="large" type="danger" @click="loginout"
            >退出</el-button
          >
        </div>
      </div>
      <div class="head-search">
        <el-input
          v-model="input"
          placeholder="请输入关键字"
          size="large"
          class="input-with-select"
        >
          <template #prepend>
            <el-select
              v-model="svalue"
              class="m-2"
              placeholder="Select"
              size="large"
              @change="selectchange"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </template>
          <template #append>
            <el-button :icon="Search" @click="serch" />
          </template>
        </el-input>
      </div>
    </div>
  </div>
</template>

<script setup>
import { get } from "@/utils/index";
import { reactive, ref } from "vue";
import { Search } from "@element-plus/icons-vue";
import { ElMessage } from "element-plus";
// router
import { useRouter } from "vue-router";
const router = useRouter();
// vuex
import { useStore } from "vuex";
const store = useStore();
let input = ref("");
let page = ref(1);
let pagesize = ref(10);
// 用户名
let headusername = ref("");
// 搜索
let svalue = ref("标题");
// 默认标题
let stype = ref(1);
const options = reactive([
  {
    label: "标题",
    value: 1,
  },
  {
    label: "作者",
    value: 2,
  },
]);
// 是否显示登录
let islogin = ref(true);
// 下拉选择
const selectchange = (val) => {
  stype.value = val;
};
// 搜索
const serch = () => {
  // 重置临时页码
  store.commit("updatepageindextemp", 1);
  router.push({
    path: "/search/list",
    query: {
      key: encodeURIComponent(input.value),
      type: stype.value,
      idx: -1,
    },
  });
};
// 更改登录状态
const editlogin = () => {
  if (window.localStorage.getItem("token")) {
    islogin.value = false;
    headusername.value = window.localStorage.getItem("username");
  } else {
    islogin.value = true;
  }
};
editlogin();
// 登录
const logins = () => {
  router.push({
    path: "/login",
    query: {},
  });
};
// 注册
const registered = () => {
  router.push({
    path: "/reg",
    query: {},
  });
};
// 个人中心
const clickgrzx = () => {
  router.push({
    path: "/pc",
    query: {
      idx: -1,
    },
  });
};
// 注销
const loginout = () => {
  ElMessage({
    message: "已退出系统！",
    duration: 1000,
    onClose: () => {
      // 清除token
      window.localStorage.removeItem("token");
      // 清除个人信息
      window.localStorage.removeItem("username");
      window.localStorage.removeItem("userInfo");
      // 清除url
      window.localStorage.removeItem("loginurl");
      editlogin();
      router.push({
        path: "/",
        query: {},
      });
    },
  });

  // post("/member/logout").then((res) => {
  //   // 清除token
  //   window.localStorage.removeItem("token");
  //   // 清除个人信息
  //   window.localStorage.removeItem("userInfo");
  //   editlogin();
  //   ElMessage({
  //     message: "已退出系统！",
  //     duration: 1000,
  //     onClose: () => {
  //       router.push({
  //         path: "/",
  //         query: {},
  //       });
  //     },
  //   });
  // });
};
// 返回首页
const clickfhsy = () => {
  router.push({
    path: "/",
    query: {},
  });
};
</script>

<style scoped>
::v-deep .el-link {
  display: block;
  text-overflow: ellipsis; /* ellipsis:显示省略符号来代表被修剪的文本  string:使用给定的字符串来代表被修剪的文本*/
  white-space: nowrap; /* nowrap:规定段落中的文本不进行换行   */
  overflow: hidden; /*超出部分隐藏*/
}
::v-deep .el-link__inner {
  display: block;
  text-overflow: ellipsis; /* ellipsis:显示省略符号来代表被修剪的文本  string:使用给定的字符串来代表被修剪的文本*/
  white-space: nowrap; /* nowrap:规定段落中的文本不进行换行   */
  overflow: hidden; /*超出部分隐藏*/
}
::v-deep .head-search .el-input-group__prepend {
  width: 60px;
}
.main-head {
  width: 100%;
  height: 80px;
}
.main-head-con {
  width: 1200px;
  height: 80px;
  margin: auto;
}
.head-logo {
  width: 500px;
  height: 80px;
  float: left;
  cursor: pointer;
}
.head-search {
  width: 300px;
  height: 80px;
  float: right;
  display: flex;
  align-items: center;
}
.head-login {
  float: right;
  width: 200px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.head-logins {
  margin-left: 10px;
}
.head-logins-dl {
  width: 110px;
  font-size: 14px;
  text-align: right;
  text-overflow: ellipsis; /* ellipsis:显示省略符号来代表被修剪的文本  string:使用给定的字符串来代表被修剪的文本*/
  white-space: nowrap; /* nowrap:规定段落中的文本不进行换行   */
  overflow: hidden; /*超出部分隐藏*/
}
.head-logins-dl:hover{
  color: #296FAB;
  text-decoration: underline;
}
.head-logout {
  float: right;
  width: 200px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.head-logins-dl {
  width: 160px;
  cursor: pointer;
}
</style>
